<script>
    export default {
        props: ['queryParam', 'id'],
        data() {
            return {
                selected: null
            };
        },
        mounted() {
            this.openOnLoad();
        },
        methods: {
            openOnLoad() {
                if (!this.queryParam || !this.id) {
                    return;
                }
                let params = new URLSearchParams(window.location.search);
                if (params.has(this.queryParam) && params.get(this.queryParam) === this.id.toString()) {
                    this.selected = this.id;
                    this.$el.scrollIntoView({
                        behavior: "smooth",
                        block: "center",
                        inline: "center",
                    });
                }
            },
            toggle(id) {
                if (this.selected === id) {
                    this.selected = null;
                } else {
                    this.selected = id;
                }
            },
            isSelected(id) {
                return this.selected === id;
            },
        },
        render(createElement) {
            return createElement('div', {
                class: {
                    active: this.isSelected(this.id)
                }
            }, [
                this.$scopedSlots.default({
                    toggle: this.toggle,
                    isSelected: this.isSelected,
                })
            ]);
        }
    };
</script>